import { getTranslation } from '@amo/core/utils/functions';
import './horaires-recontact.scss';

/**
 * Bloc vert rappelant les horaires de recontact téléphonique.
 * Affiché au-dessus du consentement téléphonique (formulaires et fenêtre de rappel).
 */
export const HorairesRecontact = ({ className = '' }) => {
    return (
        <div className={`horaires-recontact d-flex align-items-center gap-3 text-start p-3 ${className}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                focusable="false"
            >
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
            <p className={'f-14 fw-bold m-0'}>{getTranslation('recontactHours')}</p>
        </div>
    );
};
